import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { getEndpoint } from 'src/app/core/services/functions.service';

export interface Vendedor {
  codigo_vendedor: string;
  nombre_vendedor: string;
  estado: string;
}

@Injectable({
  providedIn: 'root'
})
export class VendedorService {
  //private apiUrl = 'http://127.0.0.1:8000/vendedor';
  ENDPOINT = getEndpoint('coms_vendedor');

  constructor(private http: HttpClient) { }

  getVendedores(company: string): Observable<Vendedor[]> {
    // El endpoint es solo "/" ya que obtiene todos los vendedores activos
    return this.http.get<Vendedor[]>(`${this.ENDPOINT}/`, {
      headers: { 'company': company }
    });
  }

  getVendedor(company: string,codigo: string): Observable<Vendedor> {
    return this.http.get<Vendedor>(`${this.ENDPOINT}/${codigo}`, {
      headers: { 'company': company }
    });
  }
}
